import * as server from "@/utils/http"


// 获取报告模版列表
export const _getReportTemplates=params=> server.get("/report-template/list",params)
